import styled from 'styled-components'

export const ListHeaderContainer = styled.div`
  display: flex;
  justify-content: ${props => (props.showBulkActions ? 'space-between' : 'flex-end')};
`
